import { AntdOptionType } from '@sonar-software/sonar-ts-types';
import { FilterDropdownProps } from 'antd/es/table/interface';
import { getClosestSelectionTable } from '@lib/popups';
import { MultiSelectDropdown } from '@ui/MultiSelectDropdown';
import { UserWithMetadata } from '@sonar-software/sonar-core';
import { useUsers } from '@hooks';

import React, { useMemo } from 'react';

function mapUserToOption(user: UserWithMetadata): AntdOptionType {
	return {
		label: user.fullName,
		value: String(user.id)
	};
}

export const AssignedToFilter: React.FC<FilterDropdownProps> = (props) => {
	const users = useUsers(true);

	const options = useMemo(() => users.map(mapUserToOption) ?? [], [ users ]);

	return <MultiSelectDropdown
		{ ...props }
		getPopupContainer={ getClosestSelectionTable }
		options={ options } />;
};
